const requireAllSVG = () => {
  const files = require.context('./../img/svg', false, /.*\.svg$/);
  files.keys().forEach(files);
};

export default requireAllSVG;
